import {ImpressaoService} from "../services/impressao.service";
import {PedidosService} from "../services/pedidos.service";
import {ConstantsService} from "../fidelidade/ConstantsService";
import {Component, Input, OnInit} from "@angular/core";
import {ProcessadorReciboTexto} from "../services/impressao/ProcessadorReciboTexto";

@Component({
  template: ''
})
export class ComandosImprimirComanda  implements OnInit {
  empresa: any = {};
  modoGrupoLojas: any;
  protected configImpressao: any;
  protected impressoras = [];
  opcoesImpressao = [
    'Completo',
    'Resumido'
  ];

  constructor(protected pedidosService: PedidosService, protected constantsService: ConstantsService,
              protected impressao: ImpressaoService) {
    this.pedidosService = pedidosService;
    this.constantsService = constantsService;
    this.impressao = impressao;

  }

  ngOnInit() {
    this.constantsService.empresa$.subscribe( (empresa) => {
      if (!empresa) return;
      if(!this.modoGrupoLojas){
        this.empresa = empresa;
        this.configImpressao = empresa.configImpressao;
        this.carregueImpressorasConfiguradas();
      }
      this.carregouEmpresa();
    });
  }

  carregouEmpresa(){ }

  public carregueImpressorasConfiguradas() {
    const impressorasConfiguradas = this.configImpressao?.impressoras || [];
    this.impressoras = impressorasConfiguradas.filter((impressora: any) => impressora && !impressora.removida);
  }

  public exibeSeletorImpressoras(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length > 1;
  }

  public possuiImpressoraUnicaConfigurada(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length === 1;
  }

  public obtenhaImpressoraPadrao(): any {
    return this.impressoras[0] || null;
  }

  public obtenhaLayoutPadrao(impressora: any = null, layoutPedido: string = null): string {
    let layout = layoutPedido || impressora?.layout || this.configImpressao?.layoutPedido;

    if(layout === 'Completo')
      return 'PedidoCompleto';

    if(layout === 'Resumido')
      return 'PedidoResumido';

    if(layout === 'Ambos')
      return 'PedidoCompleto';

    return layout;
  }

  imprimaLayoutUnicoComanda(comanda: any){
    if( !comanda ) { return; }

    let layout: string = this.configImpressao ? this.configImpressao.layoutPedido : null;

    if(this.configImpressao && this.configImpressao.imprimirTXT){
      this.imprimaNativamenteComandaNoLayout(comanda, layout);
    } else {
      this.imprimaComanda(comanda, layout)
    }
  }

  imprimaUmDosLeiautesComanda(comanda: any, opcao: any) {
    if( !comanda ) { return; }

    let leiaute = opcao === 'Completo' ? 'PedidoCompleto' : 'PedidoResumido';

    if(this.configImpressao && this.configImpressao.imprimirTXT){
      this.imprimaNativamenteComandaNoLayout(comanda, leiaute);
    } else {
      this.imprimaComanda(comanda, leiaute)
    }
  }

  imprimaComanda(comanda: any, layoutPedido: any) {
    let link = '/imprimir/comanda/' + comanda.id

    if(layoutPedido)
      link += '?l=' + layoutPedido

    window.open(link);
  }

  imprimaNativamenteComandaNoLayout(comanda: any, leiaute: string){
    const impressoraPadrao = this.obtenhaImpressoraPadrao();

    if(!impressoraPadrao) {
      alert('Nenhuma impressora configurada');
      return;
    }

    const impressora = {
      ...impressoraPadrao,
      layout: this.obtenhaLayoutPadrao(impressoraPadrao, leiaute)
    };

    this.imprimaNativamenteComanda(comanda, impressora)
  }

  async imprimaNativamenteComanda(comanda: any, impressora: any) {
    if(!impressora) return alert('Nenhuma impressora configurada');

    const impressoraSelecionada = {...impressora};
    const layout = this.obtenhaLayoutPadrao(impressoraSelecionada);

    if(layout)
      impressoraSelecionada.layout = layout;

    if(!impressoraSelecionada.servidorImpressao){
      await this.impressao.imprimaQzTrayComanda(comanda, impressoraSelecionada)
    } else {
      await this.impressao.envieImprimirRemotamenteComanda(comanda, impressoraSelecionada);
    }
  }
}
